import React from 'react'
import styled from 'styled-components'
import { useWindowWidth } from '@react-hook/window-size'

import { footerMenuData } from '@ui/business-components/Footer/data'

import FooterMenuGroup from '@ui/business-components/Footer/FooterMenuGroup'

const TABLET_WIDTH = 768

interface Props {
  className?: string
}

const MenuContainer = styled.nav`
  display: flex;
  gap: 2.4rem;
  justify-content: space-between;
  width: 100%;

  @media ${({ theme }) => theme.device.laptopL} {
    margin: 0 auto;
    max-width: 72.2rem;
  }

  @media ${({ theme }) => theme.device.laptop} {
    justify-content: left;
    margin-top: 0;
  }

  @media ${({ theme }) => theme.device.tablet} {
    flex-wrap: wrap;
    align-items: stretch;
  }
`

const MenuColumn = styled.div`
  flex-basis: 31.33%;
  margin: 0;

  @media ${({ theme }) => theme.device.tablet} {
    display: flex;
    flex-direction: column;
    flex-basis: 80%;
    max-width: 24rem;
    overflow: hidden;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    flex-basis: 100%;
    margin: 0;
  }
`

const Menu = ({ className }: Props) => {
  const screenWidth = useWindowWidth()

  return (
    <MenuContainer className={className}>
      <MenuColumn>
        <FooterMenuGroup title={footerMenuData.ourPrograms.groupTitle} links={footerMenuData.ourPrograms.links} />
        <FooterMenuGroup
          title={footerMenuData.forPediatricians.groupTitle}
          links={footerMenuData.forPediatricians.links}
        />
        {screenWidth < TABLET_WIDTH && (
          <>
            <FooterMenuGroup title={footerMenuData.forParents.groupTitle} links={footerMenuData.forParents.links} />
          </>
        )}
      </MenuColumn>
      <MenuColumn>
        {screenWidth < TABLET_WIDTH && (
          <>
            <FooterMenuGroup title={footerMenuData.company.groupTitle} links={footerMenuData.company.links} />
            <FooterMenuGroup title={footerMenuData.forProviders.groupTitle} links={footerMenuData.forProviders.links} />
          </>
        )}
        {screenWidth >= TABLET_WIDTH && (
          <FooterMenuGroup title={footerMenuData.forParents.groupTitle} links={footerMenuData.forParents.links} />
        )}
      </MenuColumn>
      {screenWidth >= TABLET_WIDTH && (
        <MenuColumn>
          <FooterMenuGroup title={footerMenuData.company.groupTitle} links={footerMenuData.company.links} />
          <FooterMenuGroup title={footerMenuData.forProviders.groupTitle} links={footerMenuData.forProviders.links} />
        </MenuColumn>
      )}
    </MenuContainer>
  )
}

export default Menu
